import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs/operators";
import { Contract } from "src/app/models/Contract";
import { CompanyService } from "src/app/services/company.service";

import { AuthService } from "./../../services/auth.service";
import { ContractService } from "./../../services/contract.service";

@Component({
  selector: "app-contract-info",
  templateUrl: "./contract-info.component.html",
  styleUrls: ["./contract-info.component.scss"],
  standalone: false,
})
export class ContractInfoComponent implements OnInit {
  contract: Contract;
  faSpinner = faSpinner;
  isLoading: boolean;
  contractRef: string;
  quickSearch: string = "";

  constructor(
    public contractService: ContractService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private auth: AuthService,
  ) {}

  ngOnInit() {
    this.contractRef = this.route.parent.snapshot.paramMap.get("contractReference");

    if (!this.companyService.selectedCompany?.name) return;
    this.getContractInfo();
  }

  getContractInfo() {
    this.isLoading = true;
    this.contractService
      .getContractInfo(this.companyService.selectedCompany.name, this.contractRef)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response) => {
        if (!response) {
          return;
        }
        this.contract = response;
      });
  }

  get userVisible() {
    return this.auth.user?.isUserGroupProfile;
  }
}
